import React from "react";
import styles from "./Row.module.sass";
import cn from "classnames";
import { useHistory, useParams } from "react-router";
import customers from "../../../../i11/Customers";
import { useUser } from "../../../../context";

const Row = ({
	item,
	activeTable,
	onOpen,
	activeId,
	setActiveId,
	setDetailData,
}) => {
	const { locale } = useUser();
	const { type } = useParams();
	const history = useHistory();
	const handleClick = () => {
		setActiveId(item._id);
		setDetailData(item);
		onOpen();
		history.push(`/customers/list/${type}/` + item._id);
	};

	return (
		<>
			<div
				className={cn(
					styles.row,
					{ [styles.selected]: activeId === item._id },
					{ [styles.active]: activeTable },
					{ [styles.SuspendedRow]: item.isSuspended }
				)}
			>
				<div className={styles.col} />
				<div className={styles.col}>
					<div className={styles.item} onClick={handleClick}>
						<div className={styles.avatar}>
							{isEmpty(item.profilePicture) ? (
								<div
									style={{
										backgroundColor: getRandomColor(),
									}}
								>
									{item.userName.substring(0, 2)}
								</div>
							) : (
								<img src={item.profilePicture} alt="Avatar" />
							)}
						</div>
						<div className={styles.details}>
							<div className={styles.user}>
								{`${item.userName || ""}`.toUpperCase()}
							</div>
							<div
								className={styles.login}
							>{`@${item.userName}`}</div>
							<div className={styles.email}>{item.email}</div>
						</div>
					</div>
				</div>

				<div className={styles.col}>
					<div className={styles.email}>{item.email}</div>
				</div>
				<div className={styles.col}>{item.referral || ""}</div>
				{type !== "admin" && (
					<div className={cn(styles.col)}>
						<div
							className={cn(
								styles[
									item.isSuspended ? "Suspended" : "Active"
								]
							)}
						>
							{item.isSuspended
								? customers[locale].suspended
								: customers[locale].active}
						</div>
					</div>
				)}
				{/* <div className={styles.col}>
					<div className={cn("status-green-dark", styles.purchase)}>
						{item.nfts}
					</div>
				</div> */}
				<div className={styles.col}>{item.createdAt}</div>
			</div>
		</>
	);
};

export const isEmpty = (e) => {
	return (
		e === "https://via.placeholder.com/150/FFFFFF/118800.png?text=BrandBox"
	);
};

export function getRandomColor() {
	var letters = "BCDEF".split("");
	var color = "#";
	for (var i = 0; i < 6; i++) {
		color += letters[Math.floor(Math.random() * letters.length)];
	}
	return color;
}

export default Row;
